import { valueSelector } from '@smartsheet-dataflow/formjs';
import compose from 'lodash/fp/compose';
import concat from 'lodash/fp/concat';
import { BridgeFormJSState } from '../../Types';
import { EnumParamSchema } from '../ParamSchemaTypes';
import { reduceChildren } from '../children/ChildrenFromSchema';
import { reduceLabel } from '../label/LabelFromSchema';
import { reduceValue } from '../value/ValueFromSchema';

export const reduceSelectChildren =
  (parentId: string, isMultiSelect = false) =>
  (
    state: BridgeFormJSState,
    option: EnumParamSchema['value'][0],
    index: number
  ): BridgeFormJSState => {
    let optionLbl: string;
    let optionVal: string;
    let selected: boolean;
    if (isMultiSelect) {
      selected = false;
    } else {
      selected = index === 0;
    }

    if (typeof option === 'string') {
      optionLbl = option;
      optionVal = option;
    } else {
      optionLbl = option.label;
      optionVal = option.value;
      selected = option.selected !== undefined ? option.selected : selected;
    }

    const inputId = `${parentId}.${optionVal}`;

    const [reducer, ...reducers] = [
      reduceChildren({
        inputId: parentId,
        children: concat(state.children[parentId] || [], [inputId]),
      }),
      reduceLabel({ inputId, label: optionLbl }),
      reduceValue({ inputId, value: optionVal }),
    ];

    if (selected === true) {
      if (isMultiSelect) {
        const currentDefaultValue =
          (valueSelector(parentId)(state) as string[]) || [];
        reducers.push(
          reduceValue({
            inputId: parentId,
            value: [...currentDefaultValue, optionVal],
          })
        );
      } else {
        reducers.push(reduceValue({ inputId: parentId, value: optionVal }));
      }
    }

    return compose(reducer, ...reducers)(state);
  };
